import PropTypes from "prop-types";
import React from "react";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import { getIndividualCate } from "../../helpers/product";
import { removeActiveSort } from "../../helpers/product";
import { multilanguage } from "redux-multilanguage";
import { transformFilename } from "../../helpers/imgfilename";
//import { getIndividualCateimage } from "../../helpers/product";

    
const NavCategories = ({ products,idx, currentLanguageCode }) => { 
    const uniqueCategories = getIndividualCate(products);
    const categoryList=uniqueCategories.slice(idx*13,idx*13+13)
 //   const uniqueCateimage = getIndividualCateimage(products);
 //   const cateimageList=uniqueCateimage.slice(idx*13,idx*13+13)    
    const websize="-websize"

const categoryListClick = ((e) => {
  document.querySelector('.mega-menu').style.display = 'none';
  removeActiveSort();
  setTimeout( function() {document.querySelector('.mega-menu').style.display = 'block'} , 500);
})

     return (
           
      categoryList.map((category) => {
       return (  
        <li key={category.catecode[0]} onClick={categoryListClick} > 
        <Link to={{
           pathname: "/shop/"+category.catecode[0],
           state: {type: "category", content: category.catecode[0], offset: 0 }
           }}
          >
          <div className="mega-img">
            <img src={process.env.REACT_APP_MEDIAURL + "/"+ transformFilename(category.cateimage[0],websize)} alt="" 
            onError={(e) =>{
            e.target.src='/assets/img//no-image.png'
            }}
          />
          </div>
          <div className="mega-title">
          {currentLanguageCode==='zh'?category.category[0]:category.categoryen[0]}
          </div>
        </Link>  
         </li> 
        
       )
    }
    )
     
    )
  }
        
    NavCategories.propTypes = {
        products: PropTypes.array
    };
  
    const mapStateToProps = state => {
      return{
          products: state.productData.products
      }
    };
  
export default connect(mapStateToProps)(multilanguage(NavCategories));
  